import { lazy } from 'react';

import { BaseRoles, RoleVariantEnum } from 'common/graphql/types';
import { SUPPORT_ROLES } from 'common/utils/user';
import { ReportsUrlParams } from 'module/mydata/types/types';

export const STUDY_REPORTS_PATH = `/studyreports/:${ReportsUrlParams.studyId}/:${ReportsUrlParams.reportInfo}/:${ReportsUrlParams.dashboardId}?`;
export const SITE_REPORTS_PATH = `/reports/:${ReportsUrlParams.dashboardId}?`;

const ManageCustomReports = lazy(() => import('./manage/manage_reports'));
const StudySiteData = lazy(() => import('./study_site_data'));
const StudyDataExport = lazy(() => import('./manage/study_data_export'));

export const routes = [
    {
        component: ManageCustomReports,
        path: `/studyreports/:${ReportsUrlParams.studyId}/reports/manage/custom`,
        role: [
            BaseRoles.AdminId,
            RoleVariantEnum.StudyBuilder,
            RoleVariantEnum.StudySupport,
            RoleVariantEnum.AdminReadOnly,
            ...SUPPORT_ROLES,
        ],
        permissions: ['GetCustomReportsAdminAccessToken'],
    },
    {
        component: StudySiteData,
        path: SITE_REPORTS_PATH,
        role: [
            BaseRoles.AdminId,
            RoleVariantEnum.StudyBuilder,
            RoleVariantEnum.StudySupport,
            RoleVariantEnum.SiteInvestigator,
            RoleVariantEnum.SiteCoordinator,
            RoleVariantEnum.Monitor,
            RoleVariantEnum.DataManager,
            RoleVariantEnum.Inspector,
            RoleVariantEnum.ProductSupport,
            RoleVariantEnum.DataChangeSupport,
            RoleVariantEnum.AdminReadOnly,
        ],
        permissions: ['Report_Standard_Read'],
        studySiteRequired: true,
    },
    {
        component: StudyDataExport,
        path: '/',
        role: [
            BaseRoles.AdminId,
            RoleVariantEnum.StudyBuilder,
            RoleVariantEnum.ClinicalTrialLead,
            RoleVariantEnum.StudySupport,
            RoleVariantEnum.AdminReadOnly,
            ...SUPPORT_ROLES,
        ],
    },
];
